// PieChart.js
import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import './index.css';

const EnquiresAndAdmissions = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const api = process.env.REACT_APP_API 
  const token = localStorage.getItem('jwt_token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch enquiries
        const enquResponse = await fetch(`${api}/enquiries`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (!enquResponse.ok) {
          const text = await enquResponse.text();
          throw new Error(`Enquiries fetch failed: ${text}`);
        }
        const enquData = await enquResponse.json();
        console.log('Enquiries:', enquData);
        setEnquiries(Array.isArray(enquData) ? enquData : []);

        // Fetch admissions
        const admResponse = await fetch(`${api}/admissions`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (!admResponse.ok) {
          const text = await admResponse.text();
          throw new Error(`Admissions fetch failed: ${text}`);
        }
        const admData = await admResponse.json();
        console.log('Admissions:', admData);
        setAdmissions(Array.isArray(admData) ? admData : []);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [api, token]);

  // Defensive check to avoid crash if data is not array
  const getCountsByCenter = (data, center) => {
    if (!Array.isArray(data)) return 0;
    return data.filter(item => item.centerName === center).length;
  };

  const centers = ['DWK', 'MVP', 'GWK'];

  const generateChartData = (center) => ({
    labels: ['Enquiries', 'Admissions'],
    datasets: [
      {
        data: [
          getCountsByCenter(enquiries, center),
          getCountsByCenter(admissions, center),
        ],
        backgroundColor: ['rgba(255, 99, 132, 0.6)', 'rgba(75, 192, 192, 0.6)'],
        borderColor: ['rgba(255, 99, 132, 1)', 'rgba(75, 192, 192, 1)'],
        borderWidth: 1,
        hoverOffset: 4,
      },
    ],
  });

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw}`,
        },
      },
    },
    animation: { duration: 1000, easing: 'easeOutBounce' },
  };

  if (loading) return <p>Loading charts...</p>;
  if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;

  return (
    <div className="pie-chart-container">
      {centers.map(center => (
        <div key={center} className="pie-chart-section">
          <h2 className="pie-chart-heading">{center} Center</h2>
          <Pie data={generateChartData(center)} options={options} />
        </div>
      ))}
    </div>
  );
};

export default EnquiresAndAdmissions;
